import { ExpandCircleDownOutlined } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { useState } from "react";
import CommonCard from "../commoncomponents/layout/card/CommonCard";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import yourAccount from "../../assets/images/yourAccount.png";
import updateProfile1 from "../../assets/images/updateProfile1.png";
import updateProfile2 from "../../assets/images/updateProfile2.png";
import updateProfile3 from "../../assets/images/updateProfile3.png";
import appointment from "../../assets/images/appointment.png";
import premium from "../../assets/images/premium.png";
import cellmaflex1 from "../../assets/images/cellmaflex1.png";
import cellmaflex2 from "../../assets/images/cellmaflex2.png";
import cellmaflex3 from "../../assets/images/cellmaflex3.png";
import cellmaflex4 from "../../assets/images/cellmaflex4.png";
import cellmaflex5 from "../../assets/images/cellmaflex5.png";
import patient1 from "../../assets/images/patient1.png";
import patient2 from "../../assets/images/patient2.png";
import patient3 from "../../assets/images/patient3.png";
import patient4 from "../../assets/images/patient4.png";
import patient5 from "../../assets/images/patient5.png";
import classes from "./ViewPlans.module.css";
import globalClasses from "../../component/commoncomponents/css/Global.module.css";
const WelcomePack = () => {
  const [isDoctorBenefitOpen, setIsDoctorBenefitOpen] = useState(false);
  const [isDoctorProfileUpdateOpen, setIsDoctorProfileUpdateOpen] =
    useState(false);
  const [isPatientExperienceOpen, setIsPatientExperienceOpen] = useState(false);
  const [isFAQSOpen, setIsFAQSOpen] = useState(false);
  const [isTermsAndConditionOpen, setIsTermsAndConditionOpen] = useState(false);

  const doctorBenefitOpen = () => {
    setIsDoctorBenefitOpen(!isDoctorBenefitOpen);
  };

  const doctorProfileUpdateOpen = () => {
    setIsDoctorProfileUpdateOpen(!isDoctorProfileUpdateOpen);
  };

  const patientExperienceOpen = () => {
    setIsPatientExperienceOpen(!isPatientExperienceOpen);
  };

  const frequentlyAskedQuestions = () => {
    setIsFAQSOpen(!isFAQSOpen);
  };
  const termsAndConditions = () => {
    setIsTermsAndConditionOpen(!isTermsAndConditionOpen);
  };
  return (
    <CommonLayout
      footer={true}
      hidePermium={false}
      showHeaderNavigation={true}
      isLogedIn={true}
    >
      <CommonCard>
        <>
          <Typography variant="h1" className={globalClasses.pageTitle}>
            Learn More
          </Typography>
          <Accordion sx={styles.accordion} expanded={isDoctorBenefitOpen}>
            <AccordionSummary
              expandIcon={
                <ExpandCircleDownOutlined
                  sx={{
                    color: isDoctorBenefitOpen ? "" : "success.dark",
                    p: "10px",
                  }}
                />
              }
              onClick={doctorBenefitOpen}
              sx={styles.accordionHeader}
            >
              <Typography variant="h6">Cellmaflex’s Doctor Benefits</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{ textAlign: "left", fontSize: "16px !important" }}
                className={classes.welcomeTitle}
              >
                What Do You Get?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Here’s what you get FREE when you sign up for Cellmaflex.
              </Typography>
              <br></br>
              <Typography
                sx={{ textAlign: "left", fontSize: "16px !important" }}
                className={classes.welcomeTitle}
              >
                FREE! Advertising And Marketing
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
                component="div"
              >
                Signing up with Cellmaflex allows you free advertising for your
                practice on the following platforms:
                <ul>
                  <li>Print – Newspaper Ads</li>

                  <li>Television and Radio</li>

                  <li>Billboards</li>

                  <li>Social Media – Facebook & Instagram</li>

                  <li>Google Ads</li>
                </ul>
                This gives greater visibility and marketing push on your
                practice!
              </Typography>
              <br></br>
              <Typography
                sx={{ textAlign: "left", fontSize: "16px !important" }}
                className={classes.welcomeTitle}
              >
                FREE! Patient Booking with Outlook and Google 
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                When the patient books an appointment with the Doctor, this
                appointment is sent to the doctor via <br />
                email and can be scheduled simultaneously on the doctor’s
                Outlook and Google Calendar.
                <br /> This is done at no cost to the doctor.
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left", fontSize: "16px !important" }}
                className={classes.welcomeTitle}
              >
                FREE! Access To Electronic Patient Record Solution 
              </Typography>

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Upon signing up, you have access to an Electronic Patient Record
                Solution which allows for the <br /> recording, viewing and
                updating of the patients’ online medical records. This also
                allows you to <br />
                conduct video consultations via Teams or Zoom.
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left", fontSize: "16px !important" }}
                className={classes.welcomeTitle}
              >
                FREE! Access to Cellma Practice Management Solution
              </Typography>

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Provide administration and scheduling for multiple locations
                with the click of a button.
                <br />
                Generate e-prescriptions that can be updated on the patient’s
                electronic medical record.
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left", fontSize: "16px !important" }}
                className={classes.welcomeTitle}
              >
                Cellmaflex Services
              </Typography>
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                  color: "black",
                }}
                className={classes.welcomeTitle}
              >
                Here's what you get when sign up to Cellmaflex.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Your practice is now online
              </Typography>

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Be a part of our directory, where patients can find you to book
                appointments.
              </Typography>
              <br />

              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Accept Appointments
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Patients can book appointments with you using the platform. The
                appointments can be either video
                <br /> consultations, virtual or in clinic consultations.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Upgrade to Premium
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                If you wish for additional functionality such as:
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
                component="div"
              >
                <ul>
                  <li>Customised Assessments </li>

                  <li>Customised Letters </li>

                  <li>Document Management </li>
                </ul>
                These are included in the Premium Plan.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Get Paid
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Each patient appointment has a $50 appointment fee attached,
                this fee is then split $50/$50 between <br />
                the platform and the doctor.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Need Assistance?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                To help with your Cellmaflex journey.
                <br />
                you have a few options to consider before using the platform.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Cellmaflex Support <br />
                Tutorials
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Access to easy-to-follow youtube tutorials via our cellmaflex
                channel
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Cellmaflex Support
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                For additional assistance, you can get in contact with our
                Cellmaflex Support Team at{" "}
                <a href="mailto:cellmaflexsupport@riomed.com">
                  cellmaflexsupport@riomed.com
                </a>
                or call 222-9410
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Talk to a Cellmaflex Rep
              </Typography>

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Need to get in contact with us for a non-technical concern? You
                can email us at cellmaflex@riomed.com or reach out to us on our
                socials
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={styles.accordion} expanded={isDoctorProfileUpdateOpen}>
            <AccordionSummary
              expandIcon={
                <ExpandCircleDownOutlined
                  sx={{
                    color: isDoctorProfileUpdateOpen ? "" : "success.dark",
                    p: "10px",
                  }}
                />
              }
              onClick={doctorProfileUpdateOpen}
              sx={styles.accordionHeader}
            >
              <Typography variant="h6">
                Doctor’s Profile Update and Appointment Confirmation
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                What’s Next?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Now that you’ve signed up, here’s what’s next…
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Your Account
                <br />
                Accessing your Account
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                component="div"
                className={classes.welcomeText}
              >
                To Access your account, visit Cellmaflex.com and log in using
                the doctor’s credentials you would have been assigned. <br />{" "}
                You can change this password to ensure that only you have access
                to your profile by clicking “Forgot Password”. <br />
                Please ensure that the password created has the following
                structure.
                <ul>
                  <li>Uppercase or Lower Case </li>

                  <li>Alphanumerical </li>

                  <li>1 Special Character </li>
                </ul>
                <img alt={""} src={yourAccount} className={classes.responsive} />
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                component="div"
                className={classes.welcomeTitle}
              >
                Updating your profile
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
                component="div"
              >
                Once you’ve signed into your profile, you can now update the
                information presented on the screen. <br />
                This includes your profile picture and any additional
                information you wish to include in your profile such as;
                <ul>
                  <li>Biography </li>

                  <li>Awards and Qualifications </li>

                  <li>Social Media links </li>
                </ul>
                <img alt={""} src={updateProfile1} className={classes.responsive} />
                <br />
                <br />
                Image showing update of doctor demographic information.
                <br />
                <br />
                <img alt={""} src={updateProfile2} className={classes.responsive} />
                <br />
                <br />
                Image showing additional information to be entered by the doctor
                including Education and Experience etc.
                <br />
                <br />
                <img alt={""} src={updateProfile3} className={classes.responsive} />
                <br />
                <br />
                Image showing the Clinic details including location.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Your appointments
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                component="div"
                className={classes.welcomeText}
              >
                1. When an appointment is made by a patient, the doctor and
                patient receive an email simultaneously in Outlook or Google
                calendar.
                <br />
                Their calendar is also updated.
                <br />
                2. The email will contain details of the appointment including.
                <strong>
                  {" "}
                  <ul>
                    <li>Appointment Date </li>

                    <li>Time </li>

                    <li>Location</li>

                    <li>Patient barcode. </li>
                  </ul>
                </strong>
                3. If the doctor wishes to provide video consultations,
                Microsoft Teams needs to be installed.
                <br /> (In the future, this functionality would be fully
                integrated into Cellma). <br />
                If a video appointment was booked, the doctor has the option to
                view the lobby in Cellma and to admit the patient.
                <br /> This video appointment would include the ability to “Join
                Teams Meeting”.
                <br />
                <img alt={""} src={appointment} className={classes.responsive} />
                <br />
                <br />
                An example of how the patient appointments is scheduled in
                Cellma under the doctor’s profile.
                <br />
                <br />
                4. If the patient reschedules or cancels their appointments, it
                is automatically updated in the doctor’s calendar. <br />
                5.All available appointments are available in the doctor’s
                establishment in Cellma which is accessed using the same login
                credentials as Cellmaflex.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Upgrade to Premium
              </Typography>

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
                component="div"
              >
                1.If you wish for additional functionality such as
                <br />
                <strong>
                  {" "}
                  <ul>
                    <li>Customized assessments </li>

                    <li>Customised Letters </li>

                    <li>Document Management </li>
                  </ul>
                </strong>
                These are included in the Premium Plan
                <br />
                <img alt={""} src={premium} className={classes.responsive} />
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={styles.accordion} expanded={isPatientExperienceOpen}>
            <AccordionSummary
              expandIcon={
                <ExpandCircleDownOutlined
                  sx={{
                    color: isPatientExperienceOpen ? "" : "success.dark",
                    p: "10px",
                  }}
                />
              }
              onClick={patientExperienceOpen}
              sx={styles.accordionHeader}
            >
              <Typography variant="h6">The Patient Experience</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                Booking an Appointment
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left" }}
                component="div"
                className={classes.welcomeText}
              >
                The patient can log into cellmaflex.com to search for a doctor
                either by;
                <strong>
                  {" "}
                  <ol type="a">
                    <li>Name </li>

                    <li>Location </li>

                    <li>Specialty </li>
                  </ol>
                </strong>
                <img alt={""} src={cellmaflex1} className={classes.responsive} />
                <br />
                <Typography
                  sx={{ textAlign: "left" }}
                  className={classes.welcomeText}
                >
                  Image showing Cellmaflex home page used by Patient.
                </Typography>
                <img alt={""} src={cellmaflex2} className={classes.responsive} />
                <br />
                <Typography
                  sx={{ textAlign: "left" }}
                  className={classes.welcomeText}
                >
                  Image showing the search results for Cellmaflex Clinic.
                </Typography>
                <br />
                <Typography
                  sx={{ textAlign: "left" }}
                  component="div"
                  className={classes.welcomeText}
                >
                  1. Once the doctor’s search results are shown, the patient
                  would see the following information:
                  <ol type="a">
                    <li>Doctor’s name </li>

                    <li>Clinic Name </li>

                    <li>Specialty </li>
                    <li>Rating   </li>
                    <li>Consultation cost</li>
                    <li>Booking Appointment or Video Appointment </li>
                  </ol>
                  <br />
                  2. Clicking on view profile would reveal additional details
                  about the doctor’s educational background and qualifications.
                  <br />
                  It also includes the clinic details and clinic location.
                </Typography>
                <br />
                <img alt={""} src={cellmaflex3} className={classes.responsive} />
                <br />
                <br />
                <img alt={""} src={cellmaflex4} className={classes.responsive} />
                <br />
                <br />
                3. Clicking on Book Appointment would bring up the Doctor’s
                Available times. Once the time and date is selected.
                <br /> The patient would be alerted as to the date and times.
                <br />
                <br />
                <img alt={""} src={cellmaflex5} className={classes.responsive} />
                <br />
                <br />
                Image above shows the appointment booking screen with available
                times.
                <br />
                12:30am has been selected by the patient.
                <br />
                <br />
                4. Once Continue is clicked, the patient would be prompted to
                create a patient profile.
                <br />
                <br />
                <img alt={""} src={patient1} className={classes.responsive} />
                <br />
                <br />
                5. The patient is called to register all demographic information
                before proceeding to book the appointment.
                <br />
                <br />
                <img alt={""} src={patient2} className={classes.responsive} />
                <br />
                <br />
                6.Once the profile is created, the patient clicks on the
                appointment within the appointment Tab.
                <br /> The appointment is only confirmed once the $50
                confirmation payment is made.
                <br />
                <br />
                <img alt={""} src={patient3} className={classes.responsive} />
                <br />
                Image above shows the appointment payment within the patient
                <br />
                portal where the patient pays for the confirmed appointment.
                <br />
                <br />
                <img alt={""} src={patient4} className={classes.responsive} />
                <br />
                The appointment is then included in the patient’s Appointment
                Tab
                <br />
                <br />
                <img alt={""} src={patient5} className={classes.responsive} />
                <br />
                Once payment is made, the appointment is confirmed.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={styles.accordion} expanded={isFAQSOpen}>
            <AccordionSummary
              expandIcon={
                <ExpandCircleDownOutlined
                  sx={{
                    color: isFAQSOpen ? "" : "success.dark",
                    p: "10px",
                  }}
                />
              }
              onClick={frequentlyAskedQuestions}
              sx={styles.accordionHeader}
            >
              <Typography variant="h6">
                Frequently Asked Questions (FAQ’s)
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                1. What are the benefits for utilising the platform?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                You are getting a web- accessed platform therefore making it
                easily accessible to patients at anyplace and at any time.{" "}
                <br />
                It is also an electronic way of scheduling appointments and
                storing medical records
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                2. Do the doctors always have access to change their working
                hours?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Yes, doctors can log back into their profiles and change their
                business hours, edit their profiles and include additional
                services.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                3. What are the advantages between this cloud-based platform
                compared to Others?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Other platforms are not as integrated as Cellmaflex. <br />
                Not only can it be accessed by doctors, but patients also have
                the ability to view their own records secured in one Place.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                4. Can the system be customized to specific services particular
                to a doctor?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Yes, however this is a premium feature.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                5. Is this system implemented anywhere currently?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Currently, the system is only implemented in Trinidad but there
                are plans to expand throughout the region.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                6. Can the entire Cellmaflex suite be used by doctors? That is
                all the modules?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Yes by accessing the premium package, doctors can utilise all
                the modules.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                7. Can I sign up multiple doctors under one institution?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Yes. Multiple Doctors/Users can be registered under one
                institution.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                8. Can the healthcare provider customize a pre-consultation form
                specific for a service the patient booked?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                Yes, however this functionality is only available in the premium
                package.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                9. How safe is this Cellmaflex platform in protecting my data?
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                The data in Cellmaflex is kept safe and secure using the latest
                encryption technologies for data in transit and at rest.
                <br />
                Cellmaflex is also managed and monitored by our team of
                qualified experts who manage our security operation centre to
                monitor all cellmaflex online activities and associated
                transactions.
                <br /> This service also complies and is audited against the
                relevant ISO standards and laws for data protection, information
                governance and security.
              </Typography>
            </AccordionDetails>
          </Accordion>

          <Accordion sx={styles.accordion} expanded={isTermsAndConditionOpen}>
            <AccordionSummary
              expandIcon={
                <ExpandCircleDownOutlined
                  sx={{
                    color: isTermsAndConditionOpen ? "" : "success.dark",
                    p: "10px",
                  }}
                />
              }
              onClick={termsAndConditions}
              sx={styles.accordionHeader}
            >
              <Typography variant="h6">
                Cellmaflex Platform Terms and Conditions
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                1.Introduction:
              </Typography>
              <br />

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                1.1 These terms and conditions shall govern your use of our
                platform. <br />
                <br />
                1.2 By using our platform, you accept these terms and conditions
                in full; accordingly, if you disagree with these terms and
                conditions or any part of these terms and conditions, you must
                not use our platform.
                <br />
                <br />
                1.3 If you (register with our platform,submit any material to
                our platform or use any of our services),we will ask you to
                agree to these terms and conditions.
                <br />
                <br />
                1.4 You must be at least 18 years of age to use our platform; by
                using our platform or agreeing to these terms and conditions,you
                warrant and represent to us that you are at least 18 years of
                age.
              </Typography>
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                2. Permission to use platform
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                2.1 You may:
                <br />
                <br /> (a) View pages from our platform in a web browser;
                <br />
                <br />
                (b) Print pages from our platform (for your own personal and
                non-commercial use)(providing that is not systematic or
                excessive); <br />
                <br />
                (c) Stream audio and video files from our platform (using the
                media player on our platform) and
                <br />
                <br /> (d) Use our platform by means of web browser (Additional
                list items) subject to the other provisions of these terms and
                conditions
                <br />
                <br />
                2.2 Expect as expressly permitted by Section 3.1 or the other
                provisions of these terms and conditions, you must not download
                any material from our platform or save any such material to your
                computer.
                <br />
                <br />
                2.3 You may only use of platform for providing/seeking medical
                services you must not use our platform for any other purpose
                <br />
                <br />
                2.4 Except as expressly permitted by these terms and conditions,
                you must not edit or otherwise modify any material on our
                platform.
                <br />
                <br />
                2.5 Unless you own or control the relevant rights in the
                material,you must not: (a)republish material from our platform
                (including republication on another platform or website); <br />
                <br />
                (b) Sell,rent or sub-license material from our platform; <br />
                <br />
                (c) Show any material from our platform in public; <br />
                <br />
                (d) Exploit or redistribute material from our platform for a
                commercial purpose.
                <br /> <br />
                2.6 Notwithstanding section 3.5, you may redistribute (our
                newsletter) in (print and electronic form) to (any person)
                <br />
                <br />
                2.7 We reserve the right to suspend or restrict access to our
                platform,to areas on our platform and/or to functionality upon
                our platform. We may, for example suspend access to our platform
                (during server maintenance or when we update the platform).
                <br /> You must not attempt to circumvent or bypass any access
                restriction measures on the platform.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                3.Misuse of platform:
              </Typography>
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                <br />
                3.1 You must not:
                <br />
                <br />
                (a) Use our platform in any way or take any action that causes,
                or may cause, damage to the platform or impairment of the
                performance, availability, accessibility,integrity or security
                of the platform.
                <br />
                <br />
                (b) Use our platform in any way that is unlawful,
                illegal,fraudulent or harmful or in connection with any of these
                purposes or activity;
                <br />
                <br />
                (c) Hack or otherwise tamper with our platform;
                <br />
                <br />
                (d) Probe,scan or test the vulnerability of our platform without
                our permission;
                <br />
                <br />
                (e) Circumvent any authentication or security systems or
                processes on or relating to our platform;
                <br />
                <br />
                (f) Use our platform to copy, store, host, transm it,send,use,
                publish or distribute any material whic h consists of (or is
                linked to ) any spyware, computer virus, trojan
                horse,worm.keystroke logger.rootkit or other malicious software;
                <br />
                <br />
                (g) Impose an unreasonably large load on our platform resources
                (including bandwidth,storage capacity and processing capacity);
                <br />
                <br />
                (h) Decrypt or dec ipher any communications sent by or to our
                platform without permission;
                <br />
                <br />
                (i) Conduct any systematic or automated data collection
                activities (including without limitation scraping,data
                mining,data extraction and data harvesting) on or in relation to
                our platform without our express written consent;
                <br />
                <br />
                (j) Access or otherw ise interact with our platform using any
                robot. spider or automated means,except for the purpose of
                search engine indexing;
                <br />
                <br />
                (k) Use our platform except by means of our public interfaces;
                <br />
                <br />
                (I) Use data collected from our platform for any direct
                marketing activity (including without limitation email
                marketing, SMS marketing, telemarketing and direct mailing;
                <br />
                <br />
                (m) Do anything that interferes with the normal use of our
                platform
                <br />
                <br />
                3.2 You must not use data collected from our platform to contact
                individuals, companies or other persons or entities unless
                authorised through the platform and app to do so.
                <br />
                <br />
                3.3 You must ensure that all information you supply to us
                through our platform.or in relation to our platform, is true,
                accurate, current, complete and non-misleading.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                4.Registration and accounts:
              </Typography>
              <br />

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                4.1 To be eligible for an account on our platform under this
                Section 6, doctors' registration numbers must be verified as
                well as both patients and doctors must be resident or situated
                in the regions which Cellmaflex is launched.
                <br />
                <br />
                4.2 You may register for an account with our platform by
                completing and submitting the account registration form on our
                platform, and clicking on the verification link in the email
                that the platform will send to you
                <br />
                <br />
                4.3 You must notify us if you become aware of an unauthorised
                use of your account.
                <br />
                <br />
                4.4 You must not use any other person's account to access the
                platform unless you have that person's permission to do so.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                5.User login details:
              </Typography>
              <br />

              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                5.1 If you register for an account with our platform,we will
                provide you with OR you will be asked to choose a user ID and
                password.
                <br />
                <br />
                5.2 Your user ID must not be liable to mislead and must comply
                with the content rules set out in Section 10; you must not use
                your account or user ID for or in connection with the
                impersonation of any person.
                <br />
                <br />
                5.3 You must keep your password confidential.
                <br />
                <br />
                5.4 You must notify us in writing immediately if you become
                aware of any disclosure of your password.
                <br />
                <br />
                5.5 You are responsible for any activity on our platform arising
                out of any failure to keep your password confidential, and may
                be held liable for any losses arising out of such a failure.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                6.Cancellation and suspension of account
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                6.1 We may:
                <br />
                <br />
                (a) Suspend your account;
                <br />
                <br />
                (b) Cancel your account; and/or
                <br />
                <br />
                (c) Edit your account details, at any time in our sole
                discretion with or without notice to you.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                7.Our rights to use your content
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                7.1 Within the laws of the land and in these terms and
                conditions, "your content" means all personal data entered in
                the system, your medical records, audio recordings and any other
                data shared between you and your doctor.
                <br />
                <br />
                7.2 You grant to us the access to store your content, with your
                consent on and in relation to this platform.
                <br />
                <br />
                7.3 You hereby waive all your moral rights in your content to
                the maximum extent permitted by applicable law; and you warrant
                and represent that all other moral rights in your content have
                been waived to the maximum extent permitted by applicable law.
                <br />
                <br />
                7.4 You may edit your content to the extent permitted using the
                editing functionality made available on our platform.
                <br />
                <br />
                7.5 Without prejudice to our other rights under these terms and
                conditions, if you breach any provision of these terms and
                conditions in any way, or if we reasonably suspect that you have
                breached these terms and conditions in any way, or if we
                reasonably suspect that you have breached these terms and
                conditions in any way,we may disallow access to your account.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                8.Rules about your content
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                8.1 You warrant and represent that your content will comply with
                these terms and conditions.
                <br />
                <br />
                8.2 Your content must not be illegal or unlawful,must not
                infringe any person's legal rights,and must not be capable of
                giving rise to legal action against any person (in each case in
                any j urisdiction and under any applicable law).
                <br />
                <br />
                8.3 Your content, and the use of your content by us in
                accordance with these terms and conditions. must not:
                <br />
                <br />
                (a) Be libellous or maliciously false;
                <br />
                <br />
                (b) Be obscene or indecent;
                <br />
                <br />
                (c) Infringe any copyright, moralright,database, trade mark
                right,design right, riglht in passing off or other intellectual
                property right;
                <br />
                <br />
                (d) Infringe any right of confidence, right of privacy or right
                under data protection legislation;
                <br />
                <br />
                (e) Constitute negligent advice or contain any negligent
                statement;
                <br />
                <br />
                (f) Constitute an incitement to commit a crime,instructions for
                the commission of a crime or the promotion of criminal activity;
                <br />
                <br />
                (g) Be in the contempt of any court or in breach of any court
                order;
                <br />
                <br />
                (h) Be in the breach of racial or religious hatred or
                discrimination legislation;
                <br />
                <br />
                (i) Be blasphemo us
                <br />
                <br />
                (j) Be in breach of officialsecrets legislation;
                <br />
                <br />
                (k) Be in breach of any contractual obligation owed to any
                person;
                <br />
                <br />
                (I) Depict violence in explicit,graphic or gratuitous manner;
                <br />
                <br />
                (m) Be pornographic, lewd,suggestive or sexually explicit;
                <br />
                <br />
                (n) Be untrue, false inaccurate or misleading;
                <br />
                <br />
                (o) Consist of or contain any instructions, advice or other
                information which may be acted upon and could,if acted upon,
                cause illness, injury or death or any other loss or damage;
                <br />
                <br />
                (p) Constitute spam;
                <br />
                <br />
                (q) Be offensive, deceptive,fraudulent, threatening,
                abusive,harassing, anti-social, menac ing,hateful,disc
                riminatory or inflammatory;
                <br />
                <br />
                (r) Cause annoyance, inconvenience or needless anxiety to any
                person.
                <br />
                <br />
                (s) Your content must be appropriate, civil and tasteful and
                accord with generally accepted standards of etiquette and
                behaviour on the internet.
                <br />
                <br />
                (t) You must not use our platform to link to any platform or
                webpage consisting of or containing material that would, were it
                posted on our platform breach the provisions of these terms and
                conditions.
              </Typography>
              <br />
              <br />
              <Typography
                sx={{
                  textAlign: "left",
                  fontSize: "16px !important",
                }}
                className={classes.welcomeTitle}
              >
                9.Copyright notice:
              </Typography>
              <br />
              <Typography
                sx={{ textAlign: "left" }}
                className={classes.welcomeText}
              >
                9.1 Copyright © {new Date().getFullYear()} RIOMED LTD
                <br />
                <br />
                Subject to the express provisions of these terms and conditions:
                <br />
                <br />
                (a) We, together with our licensors, own and control all the
                copyright and other intellectual property rights in our platform
                and the material on our platform;and
                <br />
                <br />
                (b) All the copyright and other intellectual property rights in
                our platform and the material on our platform are reserved
              </Typography>
            </AccordionDetails>
          </Accordion>
        </>
      </CommonCard>
    </CommonLayout>
  );
};
export default WelcomePack;
export const styles = {
  accordionHeader: {
    backgroundColor: "rgb(226 241 255)",
    flexDirection: "row-reverse",
  },
  accordion: { mb: "10px", boxShadow: 2 },
  accordionData: {
    padding: "5px",
  },
};
